import React from 'react';

const val = (data, key, fallback = '') => {
  const v = data?.[key];
  if (v === null || v === undefined) return fallback;
  return String(v);
};

const formatKoreanDate = (raw) => {
  if (!raw) return '';
  const s = String(raw).trim();
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return `${m[1]}년 ${Number(m[2])}월 ${Number(m[3])}일`;
  return s;
};

export default function MouPreview({ data }) {
  const preTitle = val(data, 'mou_pre_title', '');
  const partyA = val(data, 'party_a_name', '');
  const partyB = val(data, 'party_b_name', '');
  const docTitle = val(data, 'mou_doc_title', '업무협약서');
  const aliasA = val(data, 'party_a_alias', partyA);
  const aliasB = val(data, 'party_b_alias', partyB);
  const agreementName = val(data, 'agreement_name', '경기도 RISE 사업');
  const agreementDate = formatKoreanDate(val(data, 'agreement_date', ''));

  const extraClause = val(data, 'extra_clause', '').trim();

  const partyALogo = data?.party_a_logo || null;
  const partyAStamp = data?.party_a_stamp || null;
  const partyAOrgLabel = val(data, 'party_a_org_label', '').trim();
  const partyARole = val(data, 'party_a_role', '단장').trim();
  const partyASignName = val(data, 'party_a_sign_name', '').trim();

  const partyBLogo = data?.party_b_logo || null;
  const partyBStamp = data?.party_b_stamp || null;
  const partyBOrgLabel = val(data, 'party_b_org_label', '').trim();
  const partyBRole = val(data, 'party_b_role', '대표').trim();
  const partyBSignName = val(data, 'party_b_sign_name', '').trim();

  return (
    <div className="mou-preview-shell dfb-preview-shell">
      {/* 단일 페이지(연속 문서) */}
      <div className="mou-preview-page dfb-preview-page">
        <div className="mou-title-wrap">
          {!!preTitle && <div className="mou-title-pre">{preTitle}</div>}
          <div className="mou-title-main">{partyA && partyB ? `${partyA}와 ${partyB}` : (partyA || partyB || '')}</div>
          <div className="mou-title-doc">{docTitle}</div>
          <div className="mou-title-line" />
        </div>

        <div className="mou-body">
          <p className="mou-paragraph">
            {partyA || '당사자 A'}(이하 &quot;{aliasA || 'A'}&quot;라 한다)와 {partyB || '당사자 B'}(이하 &quot;{aliasB || 'B'}&quot;라 한다)는
            &quot;{agreementName}&quot;의 협력 체계 구축을 위하여 다음과 같이 업무협약을 체결한다.
          </p>

          <div className="mou-article">
            <div className="mou-article-title">제1조(목적)</div>
            <div className="mou-article-body">
              본 협약은 &quot;{agreementName}&quot;을 수행함에 있어 {aliasA || 'A'}와 {aliasB || 'B'}가 각각의 핵심역량을 발휘하여
              긴밀히 교류협력하고 양 기관의 발전을 도모하는 데 그 목적이 있다.
            </div>
          </div>

          <div className="mou-article">
            <div className="mou-article-title">제2조(기본원칙)</div>
            <div className="mou-article-body">
              양 기관은 본 협약서에 명기된 사항과 상대 기관의 제 규정을 상호 신의와 성실의 원칙에 따라 존중하고,
              호혜적 협력 관계를 유지한다.
            </div>
          </div>

          <div className="mou-article">
            <div className="mou-article-title">제3조(협력내용)</div>
            <div className="mou-article-body">
              <ol className="mou-ol">
                <li>
                  {aliasA || 'A'}와 {aliasB || 'B'}간 협력의 범위는 다음과 같다.
                  <ol className="mou-ol-sub">
                    <li>산업체 수요기술 공동 기초 R&amp;D 수행</li>
                    <li>첨단 산업용 AI기술, 정책, 전략 분야의 R&amp;D 협력 및 지원</li>
                    <li>산업용 AI 기술 경쟁력 강화를 위한 인재 양성</li>
                    <li>교육/연구인력 및 기술정보 교류</li>
                    <li>{agreementName} 수행</li>
                    <li>기타 양 기관의 발전을 위해 협력이 필요한 사항</li>
                  </ol>
                </li>
                <li>
                  사업별 구체적인 협력 범위 및 방안은 상호 협의에 의해 정한다.
                </li>
              </ol>
            </div>
          </div>

          <div className="mou-article">
            <div className="mou-article-title">제4조(비밀유지)</div>
            <div className="mou-article-body">
              양 기관은 업무와 관련하여 발생하는 상대 기관의 자료와 정보를 개인정보 보호법 및 관련 법령에 따라 취급하며,
              교류를 통하여 취득한 상대 기관의 비밀사항을 제3자에게 제공하거나 공개하지 않는다.
            </div>
          </div>

          {!!extraClause && (
            <div className="mou-article">
              <div className="mou-article-title">부칙(추가 조항)</div>
              <div className="mou-article-body" style={{ whiteSpace: 'pre-wrap' }}>
                {extraClause}
              </div>
            </div>
          )}

          <div className="mou-article">
            <div className="mou-article-title">제5조(효력)</div>
            <div className="mou-article-body">
              <ol className="mou-ol">
                <li>
                  본 협약은 서명된 날로부터 3년간 유효하며, 유효기간 만료일 1개월 전까지 종료 통지가 없을 경우 자동 갱신된다.
                </li>
                <li>
                  본 협약을 종료하고자 할 경우에는 언제든지 상호 협의에 따라 양해각서의 효력을 종료할 수 있다.
                </li>
              </ol>
            </div>
          </div>

          <p className="mou-paragraph">
            본 업무협약서가 유효하게 체결되었음을 증명하기 위하여 동 협약서를 2부 작성하여 양 기관이 각 1부씩 보관한다.
          </p>

          <div className="mou-date">{agreementDate}</div>

          <div className="mou-sign-row">
            {/* A */}
            <div className="mou-sign-col">
              <div className="mou-sign-logo">
                {partyALogo ? <img src={partyALogo} alt="logo-a" /> : <div className="mou-logo-spacer" aria-hidden="true" />}
              </div>
              <div className="mou-sign-org" style={{ whiteSpace: 'pre-line' }}>
                {partyAOrgLabel || partyA || ''}
              </div>
              <div className="mou-signature">
                <div className="mou-signature-text">
                  <span className="mou-role">{partyARole || ''}</span>
                  <span className="mou-name">
                    {partyASignName || ''} <span className="mou-in">(인)</span>
                  </span>
                </div>
                <div className="mou-stamp-area">
                  {partyAStamp && <img className="mou-stamp" src={partyAStamp} alt="stamp-a" />}
                </div>
                <div className="mou-sign-line" />
              </div>
            </div>

            {/* B */}
            <div className="mou-sign-col">
              <div className="mou-sign-logo">
                {partyBLogo ? <img src={partyBLogo} alt="logo-b" /> : <div className="mou-logo-spacer" aria-hidden="true" />}
              </div>
              <div className="mou-sign-org" style={{ whiteSpace: 'pre-line' }}>
                {partyBOrgLabel || partyB || ''}
              </div>
              <div className="mou-signature">
                <div className="mou-signature-text">
                  <span className="mou-role">{partyBRole || ''}</span>
                  <span className="mou-name">
                    {partyBSignName || ''} <span className="mou-in">(인)</span>
                  </span>
                </div>
                <div className="mou-stamp-area">
                  {partyBStamp && <img className="mou-stamp" src={partyBStamp} alt="stamp-b" />}
                </div>
                <div className="mou-sign-line" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

